import { Fragment, useEffect, useState } from "react";
import DashboardContainer from "../Common/Components/DashboardContainer";
import CustomerInfoWidget from "./CustomerInfoWidget";
import MachinesListWidget from "./MachinesListWidget";
import MachineDetailsWidget from "../MachineDetails/MachineDetailsWidget";
import { widgetLibrary } from "../Common/Components/widgetLibrary";
import { getCustomerListSelector, loadingCustomerListSelector } from "../Search/Slice";
import { CustomersApi } from "./api";
import DashboardSelection from "../Common/Components/DashboardSelection";
import { getSettingsSelector, updateSettings } from "../Settings/Slice";
import { updateParams, getParamsSelector } from "../Common/Slices/ParamSlice";

import { useSelector } from "react-redux";
import { useAppDispatch } from "../Core/store.hooks";
import { useParams, useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import MachineTabStrip from "./TabStripMachine";
import * as PD from "./PositionData";
import * as DBC from "./DashboardContent";
import { AuthApi } from "../Core/api";

const Customers = () => {

    const [savable, updateSavable] = useState(true);
    const [addRemove, updateAddRemove] = useState(true);
        ;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { queryparams } = useParams();

  const [urlParams, setSearchParams] = useSearchParams();
  //console.log(urlParams.get("customerId"));
    const globalParams = useSelector(getParamsSelector);
    const customerList = useSelector(getCustomerListSelector);
  const settings = useSelector(getSettingsSelector);

    const GetMachine = (customerId:string,machineSn:string) => {
            CustomersApi.getMachineList({ customerId: customerId })
                .then((response: any) => {
                    for (var i = 0; i < response.length; i++) {
                        if (response[i].machineSn == machineSn) {
                            selectMachine(response[i],customerId)
                        }
                    }
                })
                .catch((error) => {
                    if (error.message != "canceled") {
                    }
                });
        
    };
    const selectMachine = (mach: any,customerId:string) => {
        const params: any = Object.assign({}, globalParams);
        params.customerID = customerId;
        params.mainMachineSerialNo = mach.machineSn;
        params.machine = mach;
       // console.log(params)
        dispatch<any>(updateParams(params));
    };




  const [positionData, updatePositionData] = useState(PD.defaultPositionData);

  const [error, updateError] = useState(null);
  const [widgets, updateWidgets] = useState([]);
    const [urlParamsDone, updateUrlParamsDone] = useState(false);
    const [sharedLoaded, updateSharedLoaded] = useState(false);

 
  const tabstripMachineWidgets = [
    <CustomerInfoWidget
      id="1001"
      header="Customer Information"
      isBold={false}
    />,
    <MachinesListWidget id="1002" header="Machines" />,

    <MachineDetailsWidget id="2010" header="Assembly Details" />,
    <MachineTabStrip id="10000" header={globalParams.mainMachineSerialNo} />,
  ];
    useEffect(() => {
    if (!urlParamsDone) {
      if (urlParams.get("customerId") != null) {
        updateFiltersWithUrlParams();
      } else {
        navigate("/search");
      }
    }
    }, [urlParams]);


    useEffect(() => {
        if (globalParams.customerID != null){
            AuthApi.logUserEventDetail("Cutomer Dashboard", globalParams.customerID, globalParams.mainMachineSerialNo)
        }
    }, [globalParams]);


  //useEffect(() => {
  //    if (window.innerHeight < 800) {
  //        updatePositionData(defaultPositionDataSmall)
  //    }
  //    else {
  //        updatePositionData(defaultPositionData)
  //    }
  //}, [window.innerHeight]);

  const getDefaultPositionData = () => {
    if (window.innerHeight < 800) {
      return PD.defaultPositionDataSmall;
    } else {
      return PD.defaultPositionData;
    }
  };
  const getMachineDefaultPositionData = () => {
    if (window.innerHeight < 800) {
      return PD.machineDefaultPositionDataSmall;
    } else {
      return PD.machineDefaultPositionData;
    }
  };
    useEffect(() => {
        if (urlParams != null) {
            if (urlParams.get("token") != null && !sharedLoaded) {
                loadSharedDashboard();
            }
        }
    },[urlParams])
    useEffect(() => {
     // console.log(globalParams, settings)
      if (globalParams.mainMachineSerialNo == null) {
         if (settings.customerLayoutSession == "App Default Dashboard") {
            updateWidgets(DBC.dashboardCustomerWidgets);
             updatePositionData(getDefaultPositionData);
             updateSavable(true);
             updateAddRemove(true);
          } else if (settings.customerLayoutSession == "Tab Strip") {
            updateWidgets(DBC.tabstripCustomerWidgets);
             updatePositionData(PD.tabStripPositionData);
             updateSavable(false);
             updateAddRemove(false);
          } else {
             loadDashboard("customer", settings.customerLayoutSession);
             updateSavable(true);
             updateAddRemove(true);
          }
      }
      else {
      if (settings.machineLayoutSession == "App Default Dashboard") {
        updateWidgets(DBC.dashboardMachineWidgets);
          updatePositionData(getMachineDefaultPositionData);
          updateSavable(true);
          updateAddRemove(true);
      } else if (settings.machineLayoutSession == "Tab Strip") {
        updateWidgets(tabstripMachineWidgets);
          updatePositionData(PD.tabStripMachinePositionData);
          updateSavable(false);
          updateAddRemove(false);
      } else {
          loadDashboard("machine", settings.machineLayoutSession);
          updateSavable(true);
          updateAddRemove(true);
      }
    }
  }, [globalParams.machine, globalParams.customerID, settings]);


  const updateFiltersWithUrlParams = () => {
    //////////////////////////////////////////  work to be done    , dispatch from here
    if (!urlParamsDone) {
      updateUrlParamsDone(true);
      let machineSerial: any = null;
        let customerID: any = null;
        let machine: any = null;
      if (urlParams.get("customerId") != null) {
        customerID = urlParams.get("customerId");
      }
      if (urlParams.get("machine") != null) {
          machineSerial = urlParams.get("machine");
          machine = GetMachine(customerID, machineSerial);
      }
      const params: any = Object.assign({}, globalParams);
        params.mainMachineSerialNo = machineSerial;
        params.machine = machine;
      params.customerID = customerID;
      // console.log(params)
      dispatch<any>(updateParams(params));
    }
  };
  const loadDashboard = (type: string, dbName: string) => {
    let dbList = JSON.parse(localStorage.getItem("savedDashboardCustomer"));
    if (type == "machine") dbList = JSON.parse(localStorage.getItem("savedDashboardMachine"));
    if (dbList != undefined && dbList != null) {
        let dashboards = createDashboardList(dbList);
        for (var i = 0; i < dashboards.length; i++) {
            if (dashboards[i].dbName == dbName) {
                updateWidgets(dashboards[i].widgets);
                updatePositionData(dashboards[i].positionData);
               
            }
        }
    }
  };
    const savedSharedToStorage = (type:string,db:any) => {
        let newDashboardSet: any = [];
        let oldList = JSON.parse(localStorage.getItem("savedDashboardCustomer"));
        if (type=="machine") {
            oldList = JSON.parse(localStorage.getItem("savedDashboardMachine"));
        }
        if (oldList != null && oldList != undefined) {
            for (var i = 0; i < oldList.length; i++) {
                if (oldList[i].dbName != "Shared Dashboard") {
                    newDashboardSet.push(oldList[i]);
                }
            }
        }
        newDashboardSet.push({
            widgets:db.widgets,
            positionData: db.positionData,
            dbName: "Shared Dashboard",
        });

        const newSettings: any = Object.assign({}, settings);
        if (type=="machine") {
            localStorage.setItem(
                "savedDashboardMachine",
                JSON.stringify(newDashboardSet)
            );

            newSettings.machineLayoutSession = "Shared Dashboard";

            dispatch<any>(updateSettings(newSettings));

        } else {
            localStorage.setItem(
                "savedDashboardCustomer",
                JSON.stringify(newDashboardSet)
            );
            newSettings.customerLayoutSession = "Shared Dashboard";

            dispatch<any>(updateSettings(newSettings));
        }
       
    };



    const loadSharedDashboard = () => {
        let type: string = "customer";
        let machine:string = urlParams.get("machine");
        if (machine != null) type = "machine";
        let token: any = urlParams.get("token");
        let db: any = null;
        if (token != null) {
            const decodedString: any = atob(urlParams.get("token"));
            db = JSON.parse(decodedString)[0];
            if (db != null && db!=undefined) {
                //updateWidgets(createWidgetList(db.widgets));
                //updatePositionData(db.positionData);
                savedSharedToStorage(type, db);
            }

        }
        updateSharedLoaded(true);
    };

  const createDashboardList = (rawList: any) => {
    const formattedList: any = [];
    for (let i = 0; i < rawList.length; i++) {
      const obj: any = {};
      obj.dbName = rawList[i].dbName;
      obj.multiDevice = rawList[i].multiDevice;
      obj.positionData = rawList[i].positionData;
      obj.widgets = createWidgetList(rawList[i].widgets);
      formattedList.push(obj);
    }

    return formattedList;
  };
  const createWidgetList = (ids: any) => {
    const widgetList: any = [];
    for (var k = 0; k < ids.length; k++) {
      for (var i = 0; i < widgetLibrary.length; i++) {
        if (ids[k] == widgetLibrary[i].dashboardId) {
          if (ids.indexOf(widgetLibrary[i].dashboardId) > -1) {
            widgetList.push(widgetLibrary[i].component({}));
          }
        }
      }
    }
    return widgetList;
  };

    const sidebarItems: { title: string; item: any; expanded: boolean }[] = [
        { title: "Dashboard Selection", item: <DashboardSelection />,expanded:true }];

  if (error != null) {
    return <div>No customer ID found.</div>;
  }
  return (
    <Fragment>
      <DashboardContainer
        positionData={positionData}
        sidebarItems={sidebarItems}
        defaultWidgets={widgets}
        addRemove={addRemove}
        savable={savable}
      />
    </Fragment>
  );
};
export default Customers;
